import React, { useEffect, useState } from "react";
import InboxTable from './InboxTable'
import { OBPSService } from '../../../../../../../libraries/src/services/elements/OBPS';
import { Loader, Toast } from "@egovernments/digit-ui-react-components";
import FilterForm from "./FilterForm";
import { convertDateToEpoch } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import { useTranslation } from "react-i18next";

function ApplicationDetail({ setApiData, apiData }) {
    const userInfo = Digit.UserService.getUser();
    let tenantId = Digit.ULBService.getCurrentTenantId();
    let userType = userInfo?.info?.roles?.some((role => role.code === "HRMS_ADMIN" || role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN")) ? "Admin" : null
    const userDetails = Digit.SessionStorage.get("USER_DETAIL");
    const location1 = userDetails?.location1?.length > 1 ? userDetails?.location1?.concat(" Development Authority") : null;
    console.log(userDetails, userDetails?.location1, "userDetialsss");
    
    const { t } = useTranslation();
    if (userType) {
        tenantId = Digit.ULBService.getStateId()
    }
    const [isLoading, setIsLoading] = useState(true);
    const [showToast, setShowToast] = useState(null);

    const fetchData = async (tenantId, params) => {
        setIsLoading(true);
        setShowToast(null);
        try {
            const result = await OBPSService.applicationReportMISData(tenantId, params);
            console.log(result, "resultherere");
            
            if (!result) {
                throw new Error("No data received from server");
            } else if (result?.MISReportDetails?.length === 0) {
                setShowToast({
                    key: "true",
                    warning: true,
                    message: "No Records Found",
                });
            }
            setApiData(result);
        } catch (err) {
            console.error("Error fetching data:", err);
            // handle API error message if available
            const message =
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong while fetching data";
            setShowToast({
                key: "true",
                error: true,
                message: message,
            });
            setApiData(null);
        } finally {
            setIsLoading(false);
        }
    };
    const closeToast = () => {
        setShowToast(null);
    };

    const handleFormSubmit = async (formData) => {
        let {developmentAuthorityName, modulename, createdFrom, createdTo } = formData;
        if (modulename === "Plinth Submission") {
            modulename = "plinth_submission"
        } else if (modulename === "Map Compounding") {
            modulename = "FORM_MAP_COMPOUNDING"
        } else if (modulename === "Purchasable Map Submission") {
            modulename = "PURCHASABLE_MAP"
        }
        try {
            await fetchData(tenantId, { developmentAuthorityName, modulename, createdFrom, createdTo });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const fetchDataOnMount = async () => {
            await fetchData(tenantId, { developmentAuthorityName: location1 });
        };
        fetchDataOnMount();
    }, [tenantId]);


    return (
        <div>
            <FilterForm onSubmit={handleFormSubmit} userDetails={userDetails} userType={userType} location1={location1}/>
            {isLoading && (
                <div>
                    <Loader />
                </div>
            )}
            {!isLoading && showToast && (
                <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
            )}

            {!isLoading && !showToast && apiData && (
                <InboxTable apiData={apiData} />
            )}
        </div>
    );

}

export default ApplicationDetail;
